module.exports = __webpack_public_path__ + "static/media/goldPile.460de3e4.png";